import { render, staticRenderFns } from "./add_menu_dialog.vue?vue&type=template&id=0d0c40dc&scoped=true&"
import script from "./add_menu_dialog.vue?vue&type=script&lang=js&"
export * from "./add_menu_dialog.vue?vue&type=script&lang=js&"
import style0 from "./add_menu_dialog.vue?vue&type=style&index=0&id=0d0c40dc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c40dc",
  null
  
)

export default component.exports